import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

/** Fetch and cache the current user's resolved capability set.
 *  Admins always have every capability; staff get BASELINE - tenant_disabled + position.
 *  Returns { has: (cap:string) => boolean, capabilities: string[], loading: boolean }.
 */
export function useCapabilities() {
    const { user } = useAuth() || {};
    const [capabilities, setCapabilities] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if (!user) { setLoading(false); return; }
        if (user.role === "firm_admin" || user.role === "super_admin") {
            setCapabilities(["*"]); setLoading(false); return;
        }
        api.get("/positions/me")
            .then(({ data }) => setCapabilities(data?.capabilities || []))
            .catch(() => setCapabilities([]))
            .finally(() => setLoading(false));
    }, [user?.id, user?.role]);
    const has = (cap) => capabilities.includes("*") || capabilities.includes(cap);
    return { has, capabilities, loading };
}
